'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _themeSections = require('@shopify/theme-sections');

require('../../styles/sections/index-ingredients.scss');

exports.default = (0, _themeSections.register)('index-ingredients', {
  onLoad: function onLoad() {},
  onUnload: function onUnload() {}
});